import { ConversationSummary } from 'components/text_editor/plugins/ai_actions/conversation_summary';

export default ConversationSummary;
